export const TO_EMAIL_LABEL_SIGNER_CONFIRMATION = "To Email (Changes must be made on Customer Setup)";
export const TO_EMAIL_LABEL = "To Emails (use a comma for multiple addresses)";